export default __webpack_public_path__ + "static/adkins-526313e6621584d59d43faa78cd5da85.jpg";